import React, { useEffect, useState } from "react";
import { BrandData, RequestDevice } from "../../apis/Api";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
const Brand = () => {
  const [brand, setBrand] = useState([]);
  const [formData, setFormData] = useState({
    brand: "",
    model: "",
    mobile: "",
    issues: "",
  });
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const fetchBrand = async () => {
    try {
      const response = await BrandData();
      if (response) {
        setBrand(response.data);
      }
    } catch (error) {
      console.log("error getting brand data", error);
    }
  };

  const validateFields = () => {
    for (let key of Object.keys(formData)) {
      const value = formData[key]?.trim();
  
      // Empty field check
      if (!value) {
        toast.error(`Please enter ${key.replace(/_/g, " ")}`);
        return false;
      }
  
      // Mobile number validation
      if (key === "mobile") {
        console.log("Mobile input:", `"${value}"`); 
  
        const phonePattern = /^[6-9]\d{9}$/;
        if (!phonePattern.test(value)) {
          toast.error("Please enter a valid 10-digit mobile number");
          return false;
        }
      }
    }
  
    return true;
  };
  
  useEffect(() => {
    fetchBrand();
  }, []);

  const postRequest = async () => {
    if (!validateFields()) return;
    try {
      setLoading(true);
      setError(null);

      const timeoutPromise = new Promise(
        (_, reject) =>
          setTimeout(() => reject(new Error("Request timed out")), 10000) // 10 seconds timeout
      );

      const data = {
        brand: formData.brand,
        model: formData.model,
        mobile: formData.mobile,
        issue: formData.issues,
      };

      const response = await Promise.race([
        RequestDevice(data),
        timeoutPromise,
      ]);

      if (response.status === 200) {
        toast.success("Query successfully submitted");

        setError(null);
        setFormData({
          brand: "",
          model: "",
          issues: "",
          mobile: "",
        });
      } else {
        setError(`Request failed with status: ${response.status}`);
      }
    } catch (error) {
      setError("Failed to submit request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const steps = [
    {
      id: 1,
      title: "Check Price",
      description:
        "Select your device that needs to be repaired. Get best Pricing.",
      image: "assets/images/brands/brand-r.png",
    },
    {
      id: 2,
      title: "Schedule Service",
      description:
        "Book a free technician visit at your home or work at a time slot that best suits your convenience.",
      image: "assets/images/brands/brand-c.png",
    },
    {
      id: 3,
      title: "Get Device Repaired",
      description:
        "Our super-skilled technician will be there and make it as good as new.",
      image: "assets/images/brands/brand-cut.png",
    },
  ];  

  return (
    <>
      <section
        className="responsive-section all-container marginBottom"
        style={{ marginTop: "-30px", position: "relative", zIndex: 11 }}
      >
        <div className="container green-color">
          <h2 className="mb-5">Top Brands</h2>
          <div className="row text-center d-flex ">
            {brand && brand.length > 0 ? (
              <>
                {brand.map((data, index) => (
                  <Link
                    to={`/brands/${data.brand_token}`}
                    key={index}
                    className="col-lg-2 col-md-4 col-sm-4 col-4 mb-4 p-2"
                  >
                    <div
                      className="shadow brand-col d-flex flex-column align-items-center justify-content-center"
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        maxWidth: "140px",
                        aspectRatio: "1/1",
                        borderRadius: "10px",
                        background: "#fff",
                        transition: "all 0.3s ease",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={data.url}
                        alt={data.brand_name}
                        className="brand-img"
                        style={{
                          width: "70%",
                          height: "70%",
                          objectFit: "contain",
                        }}
                      />
                      <h6 className="text-capitalize fw-light">
                        {data.brand_name}
                      </h6>
                    </div>
                  </Link>
                ))}

                <div className="col-lg-2 col-md-4 col-sm-4 col-4 mb-4 p-2">
                  <div
                    data-bs-toggle="modal"
                    data-bs-target="#myModal"
                    className="shadow brand-col d-flex flex-column align-items-center justify-content-center"
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      maxWidth: "140px",
                      aspectRatio: "1/1",
                      background: "#f8f9fa",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span
                      className="findmyphone text-wrap text-center"
                      style={{ fontSize: "14px" }}
                    >
                      Can't find my phone?
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <div className="col-md-12 text-center">
                <h5>No brands found</h5>
              </div>
            )}
          </div>
        </div>
      </section>
      <div className="container">
        <div className="row text-center">
          {steps.map((step) => (
            <div
              key={step.id}
              className="col-md-4 d-flex flex-column align-items-center mb-4"
            >
              <img
                src={step.image}
                alt={step.title}
                className="mb-3"
                style={{ width: "80px", height: "80px", objectFit: "contain" }}
              />
              <div className="d-flex align-items-center gap-2">
                <span
                  className="badge rounded-circle text-white"
                  style={{
                    backgroundColor: "#73b734",
                    padding: "10px 15px",
                    fontSize: "16px",
                  }}
                >
                  {step.id}
                </span>
                <h5 className="fw-bold m-0 text-wrap">{step.title}</h5>
              </div>
              <p className="text-muted mt-2 px-3 text-wrap">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="modal fade" id="myModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title" style={{ color: "#73b734" }}>
                Submit Your Query
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">
                    Brand <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.brand}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        brand: e.target.value,
                      })
                    }
                    className="form-control border border-success"
                    placeholder="Enter brand name"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Model <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.model}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        model: e.target.value,
                      })
                    }
                    className="form-control border border-success"
                    placeholder="Enter model name"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Mobile Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.mobile}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        mobile: e.target.value,
                      })
                    }
                    className="form-control border border-success"
                    placeholder="Enter Mobile Number"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Issues <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control border border-success"
                    rows="3"
                    value={formData.issues}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        issues: e.target.value,
                      })
                    }
                    placeholder="Describe the issues"
                    required
                  ></textarea>
                </div>
              </form>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-success"
                data-bs-dismiss="modal"
                style={{ height: "40px", width: "80px" }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn"
                onClick={postRequest}
                style={{
                  backgroundColor: "#73b734",
                  color: "white",
                  height: "40px",
                  width: "80px",
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Brand;
